export default function getSbatGroupInstructorsByCategory(
  sbatGroup,
  instructorCategory
) {
  return sbatGroup.sbat_group_instructors.filter(
    (sbat_group_instructor) =>
      sbat_group_instructor.category === instructorCategory
  );
}
